export default {
  numMerchants(state) {
    return state.numMerchants
  },
  currentMerchant(state) {
    return state.currentMerchant
  },
  isMerchantLoading(state) {
    return state.merchantLoading
  },
  merchantPage(state) {
    return state.merchants
  },
  customerPage(state) {
    return state.customers
  },
  isCustomerLoading(state) {
    return state.customerLoading
  },
  numCustomers(state) {
    return state.numCustomers
  },
  accountPage(state) {
    return state.accounts
  },
  isAccountLoading(state) {
    return state.accountLoading
  },
  numAccounts(state) {
    return state.numAccounts
  },
  transactionReportURL(state) {
    return state.transactionReportURL
  },
  pageTitle(state) {
    return state.pageTitle
  },
  csvData(state) {
    return state.csvData
  }
}
